import "./OurProjects.module.css";
import Header from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import Transformation from "./sections/Transformation";
import Footer from "@/reusable_sections/Footer";
export default function OurProjectsPage() {
  return <div>
      <Header />
      <Portfolio />
      <Transformation />
      <Footer />
    </div>;
}